<template>
  <div class="block">
    <div class="container">
      <div class="title title-cust">企业合同管理现存的挑战</div>
      <div class="entitle entitle-cust">
        Existing challenges of enterprise contract management
      </div>
      <div class="row wrap-card">
        <div class="col-xs-12 col-sm-4" v-for="item in groups" :key="item.key">
          <div class="card">
            <div class="card-h">
              <div class="card-h-left">
                <img :src="icon" alt="" />
                <span> {{ item.title }} </span>
              </div>

              <img class="img-bg" :src="item.img" alt="" />
            </div>
            <div class="card-b">
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import icon from "@/assets/images/home/icon.png";
import p2 from "@/assets/images/home/p2.png";
import p3 from "@/assets/images/home/p3.png";
import p4 from "@/assets/images/home/p4.png";

const groups = [
  {
    key: 1,
    title: "范本乱",
    img: p2,
    text: "合同范本管理不统一，新老版本混用；范本限制编辑，存在被破解、造假的风险；非常用合同无范本，草拟时漏洞多、风险大，编辑、审核进度慢。",
  },
  {
    key: 2,
    title: "风险大",
    img: p3,
    text: "无预警机制，到期合同续约无提醒；审核版本与用印版本不一致，业务信息存在被篡改、删除、偷换页情况；合同签订不规范，必要信息缺失未识别，存在潜在风险；收、付款延期、提前付款，未达条件付，不能及时发现。",
  },
  {
    key: 3,
    title: "效率低",
    img: p4,
    text: "合同范本管理不统一，新老版本混用；范本限制编辑，合同份数多，内容多，页页审、行行审、次次审，审批效率低；异地合同签署流程，周期长，效率低，严重影响业务进度；合同编码不规范，纸质手工归档，付款还需带上合同；集团用印过程需耗费大量人力和时间成本。存在被破解、造假的风险；非常用合同无范本，草拟时漏洞多、风险大，编辑、审核进度",
  },
];
export default {
  data() {
    return {
      icon,
      p2,
      p3,
      p4,
      groups,
    };
  },
};
</script>

<style scoped>
.title-cust {
  color: #3975ea;
}
.entitle-cust {
  color: #b3b3b3;
}
.wrap-card {
  margin-top: 100px;
}
.card-h {
  color: #fff;
  background-color: #215dfa;
  padding-left: 20px;
  border-radius: 8px;
  height: 90px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 22px;
}
.card-h-left {
  display: flex;
}
.card-h-left img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
.card-h-left span {
  white-space: nowrap;
}
.card-h .img-bg {
  margin-right: -30px;
  width: 160px;
}

.card-b {
  padding: 20px;
  height: 204px;
  background: #f4f8fd;
  border-radius: 8px;
  font-size: 15px;
  color: #888;
}

/*  */
.mb .card {
  margin-bottom: 30px;
}
</style>